import { selectOrdersStreamingColumns } from './selectors';
import {
    PortfolioItemColumn,
    defaultPortfolioItemColumns,
} from 'portfolio/PortfolioItem';
import State from 'store/State';

export function getPortfolioColumns(state: State): PortfolioItemColumn[] {
    const orderStreamCols = selectOrdersStreamingColumns(state);
    const portfolioItemCols: PortfolioItemColumn[] = [
        ...orderStreamCols,
    ] as PortfolioItemColumn[];

    return [...defaultPortfolioItemColumns, ...portfolioItemCols];
}
